// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toolbar{z-index:1;height:4rem;cursor:auto;width:100%;background:#fff}.toolbar>button{cursor:pointer}", ""]);
// Exports
module.exports = exports;
